import { IAccessor } from '@iotize/common/data-accessor';
import { VariableType } from '@iotize/tap/service/impl/variable';

export function isTruthy(
  v: string | number | undefined,
  falsyValue = ['no', 'false', '0'],
): boolean {
  if (v === undefined) {
    return false;
  }
  if (falsyValue.indexOf(v.toString().toLowerCase()) >= 0) {
    return false;
  }
  return !!v;
}

export function convertToVariableType(accessor: IAccessor): VariableType.Data {
  let unsigned = isTruthy(accessor.value('GUI_unsigned', 'string', '0'));
  let float = isTruthy(accessor.value('GUI_float', 'string', '0'));
  const unitSize: number = accessor.value('Unit', 'number', 1);

  if (unitSize === 1) {
    const xAppRender = accessor.get('XAppRender', undefined);
    if (xAppRender) {
      const xAppRenderUnitType = xAppRender.value<'string'>(
        'GUI_UnitType',
        'string',
        undefined,
      );
      if (xAppRenderUnitType === 'ASCII') {
        return VariableType.Data.ASCII;
      }
    }
  }
  // Old version of IoTize Studio was storing UnitType ?
  const unitDataType = accessor.value('UnitType', 'string', '');
  if (unitDataType) {
    if (unitDataType === 'boolean') {
      return VariableType.Data.BOOLEAN;
    } else if (unitDataType === 'ASCII') {
      return VariableType.Data.ASCII;
    } else {
      unsigned = unitDataType === 'unsigned integer';
      float = unitDataType === 'float';
    }
  }

  if (float) {
    return VariableType.Data.FLOAT32;
  }
  switch (unitSize) {
    case 0:
      return unsigned ? VariableType.Data.UINT8 : VariableType.Data.INT8;
    case 1:
      return unsigned ? VariableType.Data.UINT8 : VariableType.Data.INT8;
    case 2:
      return unsigned ? VariableType.Data.UINT16 : VariableType.Data.INT16;
    case 3:
      return unsigned ? VariableType.Data.UINT32 : VariableType.Data.INT32;
    default:
      throw new Error(
        `Unknown unit size: "${unitSize}" (type=${typeof unitSize})`,
      );
  }
}

export function fromMapping<T>(
  data: IAccessor,
  attributeName: string,
  mapping: Record<string, T>,
  defaultValue?: string,
): T | undefined {
  let value = data.value(attributeName, 'string', defaultValue);
  if (!value) {
    return undefined;
  }
  value = value.replace(/ /g, '_').toUpperCase();
  if (!(value in mapping)) {
    throw new Error(`Invalid value "${value}" for key "${attributeName}"`);
  }
  return mapping[value];
}

/**
 * TODO add to common lib (toEnumFromValue)
 * @param mapping
 * @param value
 */
export function stringToEnum<OutputType>(
  mapping: any,
  value: string,
): OutputType {
  const values = Object.keys(mapping).map((key) => mapping[key]);
  if (
    values.find((v: string | number) => v.toString() === value) === undefined
  ) {
    throw new Error(
      `Missing value "${value}" in enum. Available keys are ${values.join(
        ', ',
      )}`,
    );
  }
  if (value in mapping) {
    // For string to number convertion
    return mapping[mapping[value]];
  }
  return value as any as OutputType;
}

export function mapKey<T>(object: T, key: keyof T, value: T[keyof T]) {
  if (value) {
    object[key] = value;
  }
}

// /**
//  * Checks if current bundle can be seen by the current user
//  * @param {string} profile name of the profile
//  * @returns {boolean} true if bundle is visible to the user
//  */

// isVisibleTo(profile: string) {
//         let isVisible;

//         switch (profile) {
//                 case 'admin':
//                 return true;

//                 case 'supervisor':
//                 return (this.rights.length !== 1 || this.rights.find( right => right.profile === 'admin') === undefined);

//                 default :
//                 isVisible = this.rights.find( right => right.profile === profile? true : right.profile === 'anonymous');
//         }
//         return isVisible !== undefined ? true : false;
// }

// /**
//  * Checks if current bundle can be written by the current user
//  * @param profile name of the profile
//  * @returns {boolean} true if bundle is writable by the user
//  */
// isWritableBy(profile: string) {

//         switch (profile) {
//                 case 'admin':
//                 return this.rights.find(right => right.write) !== undefined;

//                 case 'supervisor':
//                 return this.rights.find(right => (right.write && right.profile !== 'admin')) !== undefined;

//                 default :
//                 const profileRights = this.rights.find( right => right.profile === profile);
//                 const anonymousRights = this.rights.find( right => right.profile === 'anonymous');

//                 return (profileRights && profileRights.write)? true : (anonymousRights && anonymousRights.write)? true : false;
//         }

// }
